<template lang="pug">

.bs
	Loading(v-show="initialFail && !isBoxscoreReady")

	transition(name='fade')
		.bs-head(v-show="isBoxscoreReady && referees.length")
			.bs-head-shield-wrap
				.ge-head_team.ge-head_team--bs(
					role="button"
					@click="selectTeam('local')"
					:class="isLocalSelected ? 'ge-head_team--bs_selected' : ''"
					)
					img.ge-head_team__img(:src="$store.state.match.localImage", :alt="$store.state.match.localShortName")
					span.ge-head_team__name {{ $store.state.match.localShortName }}

				.ge-head_team.ge-head_team--bs(
					role="button"
					@click="selectTeam('visitor')"
					:class="!isLocalSelected ? 'ge-head_team--bs_selected' : ''"
					)
					img.ge-head_team__img(:src="$store.state.match.visitorImage", :alt="$store.state.match.visitorShortName")
					span.ge-head_team__name {{ $store.state.match.visitorShortName}}
			NavQuarter(class="fi-per-wrap--end")

	transition(name='fade')
		.bs-upcoming_msg(v-if="$store.state.match.status == 'roaster-ready'")
			span 
				| *
				| {{ $t('Boxscore upcoming warning') }}
	transition(name='fade')
		.ta-wrap(v-show="isBoxscoreReady && referees.length")
			BoxScoreTable(:key="idMatch")

	transition(name='fade')
		.bs-table(v-show="isBoxscoreReady && referees.length")
			.bs-data-wrap
				.bs-data-subwrap
					.bs-data
						h4.bs-data__title {{ $t('Coach') }}
						.bs-data-list(v-if="coach_list.coach.license")
							span.bs-data__item {{ coach_list.coach.license.licenseStr15}}
					.bs-data
						h4.bs-data__title {{ $t('Assistants') }}
						ul.bs-data-list(v-if="coaches.local.assistants.length")
							li.bs-data__item(v-for="assistant in coach_list.assistants") {{ assistant.license.licenseStr15}}
				.bs-data.bs-data--ref
					h4.bs-data__title {{ $t('Referee') }}
					ul.bs-data-list
						li.bs-data__item(v-for="referee in referees") {{ referee.license.licenseStr15}}
			.bs-data-wrap.bs-data-wrap--more_info
				.bs-data.bs-data--inline(v-if="parsedDate && parsedTime") 
					h4.bs-data__title {{ $t('Date') }}:
					span.bs-data__item {{ parsedDate }}
					span.bs-data__item | {{ parsedTime }}

				.bs-data.bs-data--inline(v-if="$store.state.match.arena")
					h4.bs-data__title {{ $t('Court') }}:
					span.bs-data__item {{ $store.state.match.arena }}

				.bs-data.bs-data--inline(v-if="$store.state.match.crowd")
					h4.bs-data__title {{ $t('Attendance') }}:
					span.bs-data__item {{ $store.state.match.crowd }}


</template>

<style lang="sass">

.bs
	display: grid
	grid-auto-flow: row
	justify-content: center
	margin: 0 auto
	padding: 4rem 1rem
		bottom: 16rem
	// grid-gap: 2rem
	box-sizing: border-box
	width: 100%
	&-head
		display: grid
		grid-template-columns: 1fr
		justify-items: center
		grid-column-gap: 1rem
		grid-row-gap: 3rem
		padding-bottom: 2rem

		+breakpoint(400px)
			grid-template-columns: 1fr 1fr
			justify-items: start
		+breakpoint(large)
			grid-template-columns: 1fr max-content 1fr
		
		&-shield	
			&-wrap
				display: grid
				grid-template-columns: repeat(2,80px)
				grid-gap: 1rem
	&-table
		display: grid
		grid-auto-flow: row
		+breakpoint(large)
			grid-gap: 3rem
	
	&-upcoming_msg
		display: flex
		// justify-content: center
		font-size: .85em
		// font-weight: $bold
		padding-bottom: 1.5rem
		line-height: 1.1em
		// text-align: right
		+breakpoint(large)
			font-size: .9em
			justify-content: flex-end
		

	&-data
		display: grid
		grid-auto-flow: row
		grid-gap: 1rem
		align-content: start
		width: 205px


		&--ref
			.bs-data-list
				background-color: initial
			.bs-data__item
				padding-left: 0
				line-height: 1em
		&--inline
			grid-auto-flow: column
			justify-content: start
			grid-gap: 0.4rem
			align-items: center
			padding: 0.3rem 0
			width: initial
			.bs-data__item
				padding: 0
			.bs-data__title, .bs-data__item
				line-height: 1em

		&-wrap
			display: flex
			flex-direction: column
			justify-content: space-between
			padding: 3rem 0
			+breakpoint(medium)
				flex-direction: row
			
			&--more_info
				justify-content: initial
				padding: 0
				+breakpoint(medium)
					flex-direction: column

		&-subwrap
			display: grid
			grid-template-columns: auto
			padding-bottom: 2rem

			+breakpoint(large)
				grid-template-columns: repeat(2, auto)
				padding-bottom: 0
			& > *
				margin-right: 2rem
				box-sizing: border-box
				padding-bottom: 2rem
				+breakpoint(large)
					padding-bottom: 0
	
		&-list
			list-style: none
			padding: 0
			margin: 0
			background-color: $white


		&__title
			font-size: 0.8em
			text-transform: uppercase
		&__item
			padding: 0.3rem
			box-sizing: border-box
			display: block
			width: 100%

			


</style>

<script>

import api from "@/api/index"

import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue"
import BoxScoreTable from "@/components/subcomponents/BoxScoreTable.vue"
import Loading from "@/components/subcomponents/general/Loading.vue"

export default {
	name: "BoxScore",
	data() {
		return {
			coaches: {
				local: {
					coach: { license: { licenseStr15: '' } },
					assistants: []
				},
				visitor: {
					coach: { license: { licenseStr15: '' } },
					assistants: []
				}
			},
			referees: [],
			initialFail: false,
			initialTimer: null,
		}
	},
	computed: {
		refreshSignal() {
			return this.$store.state.general.refreshSignal
		},
		isBoxscoreReady() {
			return this.$store.state.general.isBoxscoreReady
		},
		isLocalSelected() {
			return this.$store.state.match.selTeam == 'local'
		},
		coach_list() {
			return this.isLocalSelected ? this.coaches.local : this.coaches.visitor
		},
		idMatch() {
			return this.$route.params.id_match
		},
		actual() {
			return this.$store.state.general.actual
		},
		parsedDate() {
			if (this.$store.state.match.start_date) {
				let d = new Date(this.$store.state.match.start_date * 1000);
				return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
			}
			return false
		},
		parsedTime() {
			if (this.$store.state.match.start_date) {
				let d = new Date((this.$store.state.match.start_date) * 1000);
				return d.toTimeString().substr(0, 5);
			}
			return false
		},
	},
	methods: {
		selectTeam(team) {
			this.$store.commit('match/setTeam', team)
		},
		getCoachAndReferee() {
			api.match.getCoachAndReferee(this.$route.params.id_match)
				.then((data) => {
					this.$data.coaches = data.coaches
					this.$data.referees = data.referees
				}
				)
		},
		setInitialTimer() {
			this.initialTimer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				clearTimeout(this.initialTimer)
				this.$data.initialFail = false
			}
		},
	},
	watch: {
		actual: {
			handler: function () {
				this.getCoachAndReferee()
			},
			deep: true
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing) {
					this.getCoachAndReferee()
				}
			}
		}
	},
	created() {
		this.setInitialTimer()
		this.$store.commit('general/setBoxscoreReady', false)
	},
	mounted() {
		this.$parent.triggerGlobalRefresh()
		this.getCoachAndReferee()
		this.$parent.goTop()
	},
	components: {
		NavQuarter,
		BoxScoreTable,
		Loading
	}
}

</script>